import React from 'react'

export interface SvgIconProps {
    color: string
}

/**
 *
 * @param color represents the color of the SVG icon.
 * The path in this svg is similar to path in "public/assets/images/map/Vessel_Fill_AIS_Orange.svg"
 * @returns
 */
const VesselIcon: React.FC<SvgIconProps> = ({ color }) => {
    return (
        <svg
            width="24"
            height="26"
            viewBox="0 0 143 125"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M84.1281 7.24603C84.1281 3.25823 80.8837 0.013916 76.8959 0.013916H66.1042C62.1164 0.013916 58.8721 3.25823 58.8721 7.24603V18.0584H84.1281V7.24603Z"
                fill={color}
            />
            <path
                d="M72.5585 45.2599L114.48 56.2134V29.1805C114.48 27.6678 113.249 26.4373 111.736 26.4373H31.2628C29.7501 26.4373 28.5195 27.6678 28.5195 29.1805V56.2134L70.4406 45.2599C71.1346 45.0786 71.8642 45.0786 72.5585 45.2599Z"
                fill={color}
            />
            <path
                d="M138.81 116.607C134.187 116.607 132.101 115.568 129.46 114.253C128.22 113.635 126.912 112.984 125.352 112.43C123.186 111.66 120.532 111.076 116.895 111.025L132.234 72.4112C132.573 71.4943 132.302 70.7309 132.108 70.3558C131.913 69.9777 131.443 69.306 130.484 69.0554L71.4997 53.6436L12.5153 69.0554C11.5562 69.306 11.0861 69.9777 10.8915 70.3558C10.6979 70.7312 10.4262 71.4954 10.7666 72.4126L26.0712 111.025C22.4354 111.08 19.7837 111.668 17.6192 112.441C16.0721 112.993 14.7731 113.639 13.5412 114.253C10.8998 115.568 8.81377 116.607 4.18945 116.607C1.87576 116.607 0 118.483 0 120.796C0 123.11 1.87576 124.986 4.18945 124.986C10.7842 124.986 14.233 123.269 17.2756 121.754C18.4612 121.164 19.5363 120.63 20.7777 120.22C22.3024 119.717 24.0785 119.4 26.6273 119.4C27.2091 119.4 27.7504 119.417 28.2581 119.448C31.7851 119.666 33.6701 120.604 35.979 121.754C39.0217 123.269 42.4704 124.986 49.0652 124.986C55.6597 124.986 59.1082 123.269 62.1511 121.754C64.7921 120.439 66.8782 119.4 71.502 119.4C76.1257 119.4 78.2115 120.439 80.8525 121.754C83.8952 123.269 87.3437 124.986 93.9381 124.986C100.533 124.986 103.981 123.269 107.024 121.754C109.34 120.601 111.23 119.66 114.778 119.446C115.276 119.416 115.806 119.4 116.375 119.4C118.896 119.4 120.66 119.71 122.173 120.204C123.436 120.616 124.524 121.156 125.725 121.754C128.768 123.269 132.216 124.986 138.811 124.986C141.125 124.986 143 123.11 143 120.797C143 118.483 141.124 116.607 138.81 116.607ZM32.7677 75.0835L70.4406 65.24C71.135 65.0587 71.8645 65.0587 72.5588 65.24L110.232 75.0835C112.47 75.6683 113.811 77.9575 113.226 80.196C112.734 82.0796 111.035 83.3275 109.176 83.3275C108.825 83.3275 108.469 83.2831 108.114 83.1904L71.4997 73.6236L34.8859 83.1904C32.6473 83.7752 30.3582 82.4346 29.7733 80.196C29.1885 77.9575 30.5291 75.6683 32.7677 75.0835Z"
                fill={color}
            />
        </svg>
    )
}

export default VesselIcon
